import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { MobileAppStiRanking } from '../models/mobileAppStiRanking';

@Component({
  template: `<seller-risks [data]="data"></seller-risks>`,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SellerRiskComponent extends DataWidgetComponent implements OnInit {
  @Input()
  data: MobileAppStiRanking;

  ngOnInit() {
    super.ngOnInit();
  }
}
